import { create } from 'zustand'
import recruiterService, { RecruiterProfile } from '@/services/recruiterService'

interface RecruiterState {
  profile: RecruiterProfile | null
  profileLoaded: boolean
  refreshProfile: () => Promise<void>
}

export const useRecruiterStore = create<RecruiterState>((set) => ({
  profile: null,
  profileLoaded: false,

  refreshProfile: async () => {
    try {
      const profile = await recruiterService.getProfile()
      set({ profile, profileLoaded: true })
    } catch {
      // Silently fail — stale data is better than crashing
      set({ profileLoaded: true })
    }
  },
}))
